import React from 'react';
import { Space, Avatar } from 'antd';

// Transaction rows of the permission matrix, in display order.
// `key` is the column name returned by GET /admin/user-matrix.
export const MATRIX_TRANSACTIONS = [
  { name: 'Material Receipt', key: 'material_receipt' },
  { name: 'Material Movement', key: 'material_movement' },
  { name: 'Sampling / TRF', key: 'sampling_trf' },
  { name: 'Material Status Update', key: 'material_status_update' },
  { name: 'Dispensing Request', key: 'dispensing_request' },
  { name: 'Dispensing Execution', key: 'dispensing_execution' },
  { name: 'Dispensing Approval', key: 'dispensing_approval' },
  { name: 'Stock Hold / Release', key: 'stock_hold_release' },
  { name: 'Stock Deduction', key: 'stock_deduction' },
  { name: 'Stock Reconciliation', key: 'stock_reconciliation' },
  { name: 'Material Return Request', key: 'material_return_request' },
  { name: 'Code to Code Transfer', key: 'code_to_code_transfer' },
  { name: 'Vendor / Material Master', key: 'vendor_material_master' },
  { name: 'Line Clearance', key: 'line_clearance' },
  { name: 'Material Verification', key: 'material_verification' },
  { name: 'Material Verification Report', key: 'material_verification_report' },
  { name: 'Product Verification', key: 'product_verification' },
  { name: 'Product Verification Report', key: 'product_verification_report' },
  { name: 'DRUM Label Generation', key: 'drum_label_generation' },
  { name: 'DRUM Allocation', key: 'drum_allocation' },
  { name: 'Sieve/Screen Label Generation', key: 'sieve_label_generation' },
  { name: 'Sieve/Screen Allocation', key: 'sieve_allocation' },
  { name: 'WIP Weighing Labels', key: 'wip_weighing_labels' },
  { name: 'BOM Creation', key: 'bom_creation' },
  { name: 'Equipment Master', key: 'equipment_master' },
  { name: 'EBMR Configuration', key: 'ebmr_configuration' },
  { name: 'EBMR Execution', key: 'ebmr_execution' },
  { name: 'EBMR Event Review', key: 'ebmr_event_review' },
  { name: 'EBMR Approval', key: 'ebmr_approval' },
  { name: 'Electronic Logbooks', key: 'electronic_logbooks' },
  { name: 'Reports', key: 'reports' },
  { name: 'Audit Trail', key: 'audit_trail' },
  { name: 'User Management', key: 'user_management' }
];

// Renders permission avatars from the code stored per transaction (e.g. 'VC', 'VCE')
export const renderPermission = (code) => {
  if (!code) return 'NA';

  return (
    <Space>
      {code.includes('V') && (
        <Avatar
          style={{ backgroundColor: 'blue', verticalAlign: 'middle' }}
          size="small"
        >
          V
        </Avatar>
      )}
      {code.includes('C') && (
        <Avatar
          style={{ backgroundColor: 'Green', verticalAlign: 'middle' }}
          size="small"
        >
          C
        </Avatar>
      )}
      {code.includes('E') && (
        <Avatar
          style={{ backgroundColor: '#FFBF00', verticalAlign: 'middle' }}
          size="small"
        >
          E
        </Avatar>
      )}
      {code.includes('D') && (
        <Avatar
          style={{ backgroundColor: '#dc3545', verticalAlign: 'middle' }}
          size="small"
        >
          D
        </Avatar>
      )}
    </Space>
  );
};

// The API returns an array with a single matrix row for the role/level; Redux stores it
// as-is. Missing/empty response degrades to every transaction showing 'NA'.
export const buildMatrixTransactions = (userMatrix) => {
  const matrix = (Array.isArray(userMatrix) ? userMatrix[0] : userMatrix) || {};

  return MATRIX_TRANSACTIONS.map(({ name, key }) => ({
    name,
    permission: renderPermission(matrix[key])
  }));
};

export const matrixColumns = [
  {
    title: 'Transactions',
    dataIndex: 'name',
    key: 'name',
    ellipsis: true,
    width: '100px',
    render: (text) => {
      return <b style={{ fontSize: '12px' }}>{text}</b>;
    }
  },
  {
    title: `Permissions`,
    dataIndex: 'permission',
    key: 'permission',
    ellipsis: true,
    width: '100px'
  }
];
